import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from "@angular/core";
import { FormGroup, ReactiveFormsModule } from "@angular/forms";

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: "vw-text-box",
  templateUrl: "./text-box.component.html",
  imports: [ReactiveFormsModule],
})
export class TextBoxComponent {
  readonly label = input<string>();
  readonly labelClass = input<string>();
  readonly id = input<string>();
  readonly type = input<string>();
  readonly formControlProp = input<string | number>();
  readonly parentForm = input.required<FormGroup>();
  readonly clearButton = input<boolean>();
  readonly buttonText = input<string>();
  readonly buttonDisabled = input<boolean>();
  readonly placeholder = input("");

  readonly invalid = input<boolean>();
  readonly loading = input<boolean>();

  readonly clear$ = output<void>();
  readonly buttonClick$ = output<void>();

  constructor() {}

  clear(): void {
    // TODO: The 'emit' function requires a mandatory void argument
    this.clear$.emit();
  }

  buttonClick(): void {
    // TODO: The 'emit' function requires a mandatory void argument
    this.buttonClick$.emit();
  }
}
